<template>
<div
  class="row"
  v-loading="loading"
>
  <!-- @TODO Remover linha abaixo de teste -->
  <!--    <div class="col-xs-12" v-if="userLogged.role === 'superadmin'"> <button @click="generateTest()" class="btn">Gerar testes</button> </div>-->

  <div class="col-xs-12">
    <div class="row">
      <div class="col-lg-7 col-xs-12">
        <event-card
          v-loading="eventLoading"
          :event="event"
          :show-edit-button="false"
        />
      </div>

      <div class="col-lg-5 col-xs-12">
        <circle-chart-card
          v-loading="loading"
          :percentage="percentage"
          title=""
          :description="`Pesquisas realizadas ${countTicketsSurveyed} de ${countTotalTickets}.`"
          color="blue"
        ></circle-chart-card>
      </div>
    </div>
  </div>

  <div
    class="col-lg-6 col-xs-12"
    v-loading="loading"
  >
    <survey-list-filters
      :tickets="tickets"
      :customers="customers"
      @changeFilter="onChangeFilter($event)"
    ></survey-list-filters>
  </div>

  <div
    class="col-lg-6 col-xs-12"
    v-loading="savingLoading"
  >
    <survey-actions
      :event="event"
      :enableAssociate="enableAssociate"
      @runAssociateAll='runAssociateAll()'
      @setUser="onUsersSelected($event)"
    ></survey-actions>
  </div>

  <div
    class="col-xs-12"
    v-loading="loading"
  >
    <survey-tickets-list-to-associate
      :tickets="tickets"
      :customers="customers"
      :surveys-prop="surveys"
      :clean="cleanBox"
      :filters="filters"
      @surveyDocuments="onSurveyDocuments($event)"
    ></survey-tickets-list-to-associate>
  </div>
</div>
</template>

<script>
import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
import EventCard from 'src/pages/Events/EventCard'
import SurveyActions from './SurveyActions'
import SurveyListFilters from './SurveyListFilters'
import SurveyTicketsListToAssociate from './SurveyTicketsListToAssociate'
import UsersOptions from 'src/components/UsersOptions'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'survey-index',

  components: {
    CircleChartCard,
    EventCard,
    SurveyActions,
    SurveyListFilters,
    SurveyTicketsListToAssociate,
    UsersOptions
  },

  data () {
    return {
      userSelected: {},
      customersSelected: [],
      eventSelected: {},
      surveysDocuments: [],
      filters: {
        status: [],
        neighborhood: [],
        users: []
      },
      cleanBox: 1
    }
  },

  computed: {
    ...mapGetters({
      userLogged: 'user'
    }),
    ...mapGetters('users', {
      users: 'usersIdName'
    }),
    ...mapGetters('events', {
      event: 'event',
      eventLoading: 'loading'
    }),
    ...mapGetters('tickets', {
      tickets: 'tickets',
      ticketsLoading: 'loading'
    }),
    ...mapGetters('customers', {
      customers: 'modelById',
      customersLoading: 'loading'
    }),
    ...mapGetters('surveys', {
      surveys: 'surveys',
      savingLoading: 'loading'
    }),

    loading () {
      return this.savingLoading || this.ticketsLoading || this.customersLoading
    },

    eventId () {
      return this.$route.params.id
    },

    enableAssociate () {
      return this.userSelected.hasOwnProperty('_id') &&
        this.userSelected._id !== '' && this.surveysDocuments.length > 0
    },

    countTicketsSurveyed () {
      return this.surveys.filter(item => {
        return item.status === 'FINISHED'
      }).length
    },

    countTotalTickets () {
      return this.tickets.length
    },

    percentage () {
      return this.countTotalTickets > 0 ? Math.floor((this.countTicketsSurveyed / this.countTotalTickets) * 100) : 0
    }
  },

  methods: {
    ...mapActions('events', {
      fetchEvent: 'fetchOne',
      resetEvent: 'resetOne',
      changeEventLoading: 'changeLoading'
    }),

    ...mapActions('tickets', {
      fetchTickets: 'fetchAll',
      resetTickets: 'resetAll',
      changeTicketLoading: 'changeLoading'
    }),

    ...mapActions('surveys', {
      associateSurveys: 'associateSurveys',
      fetchSurveys: 'fetchAll',
      resetSurveys: 'resetAll',
      changeSurveyLoading: 'changeLoading'
    }),
    ...mapActions('users', {
      fetchUsers: 'fetchAll',
      changeSurveyLoading: 'changeLoading'
    }),
    ...mapActions('customers', {
      changeCustomerLoading: 'changeLoading',
      fetchCustomersById: 'fetchIds'
    }),

    runAssociateAll () {
      return this.associateSurveys(
        this.surveysDocuments.map(item => Object.assign(
          item, {
            user: {
              _id: this.userSelected._id,
              name: this.userSelected.name
            }
          }
          )
        )
      ).then(response => {
        if (response) {
          this.$notify({
            message: 'Cliente associado com sucesso. Aguarde atualização da tela.',
            type: 'success'
          })
        } else {
          this.$notify({
            message: 'Ocorreu um erro ao associar o cliente. Contate o suporte.',
            type: 'danger'
          })
        }
        this.cleanBox++
        this.surveysDocuments = []
        this.userSelected = {}
      })
    },

    onUsersSelected (user) {
      this.userSelected = user
    },

    onSurveyDocuments (surveys) {
      const surveyTypes = this.event.surveysType && this.event.surveysType.length > 0 ? this.event.surveysType : ['refrigerator']
      this.surveysDocuments = surveys.map(newSurvey => {
        newSurvey.user = this.userSelected
        newSurvey.event = {
          _id: this.eventId,
          name: `${this.event.reference} - ${this.event.city} - ${this.event.place}`
        }
        newSurvey.userId = this.userLogged._id
        return newSurvey
      }).reduce((accum, current) => {
        for (let type of surveyTypes) {
          current.surveyType = type
          accum.push(Object.assign({}, current))
        }
        return accum
      }, [])
      console.log('onSurveyDocuments', this.surveysDocuments)
    },

    onChangeFilter (filters) {
      this.filters = false
      this.$nextTick(() => {
        this.filters = filters
      })
    },

    reset () {
      this.userSelected = {}
      this.resetEvent()
      this.resetTickets()
      this.resetSurveys()
    },

    fetch () {
      Promise.all([
        this.fetchSurveys({
          where: {
            'event._id': this.eventId
          },
          limit: 9999999999
        }),
        this.fetchTickets({
          where: {
            'eventId': this.eventId
          },
          limit: 9999999999
        }),
        this.fetchEvent(this.eventId),
        this.fetchUsers({
          where: { role: { '$ne': 'superadmin' } },
          limit: 999999
        })
      ]).then(results => {
        Promise.all([
          this.fetchCustomersById({ ids: results[1].map(item => Object.assign({}, { id: item.customerId })) })
        ])
      })
    },

    // @TODO: Remover função abaixo de teste
    generateTest () {
      let axios = require('axios')
      let surveys = this.surveys.map(survey => {
        survey.status = 'FINISHED'
        survey.data = {
          absent: false,
          accepted: true,
          reasonNotPresent: null,
          reasonNotAccepted: null,
          refrigerator: {
            yearsUse: Math.floor(Math.random() * Math.floor(2) + 5),
            body: Math.floor(Math.random() * Math.floor(4)),
            doors: Math.floor(Math.random() * Math.floor(4)),
            coil: Math.floor(Math.random() * Math.floor(4)),
            rubber: Math.floor(Math.random() * Math.floor(4)),
            compartments: Math.floor(Math.random() * Math.floor(4)),
            engine: Math.floor(Math.random() * Math.floor(4)),
            manufacturer: 'Brastemp',
            sealingNumber: '558658',
            score: (Math.random() * 3 + 5).toFixed(3)
          }
        }
        return survey
      })
      axios({
        baseURL: `${process.env.DB_SURVEYS_HOST}/trg_surveys`,
        url: `_bulk_docs`,
        method: 'post',
        withCredentials: true,
        auth: {
          username: process.env.DB_SURVEYS_USER,
          password: process.env.DB_SURVEYS_PASS
        },
        data: { docs: surveys }
      })
    }
  },

  mounted () {
    this.reset()
    this.fetch()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Surveys/SurveysIndex.vue